import { render, staticRenderFns } from "./PaymentsPage.vue?vue&type=template&id=46e5401e&scoped=true&lang=html&"
import script from "./PaymentsPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsPage.vue?vue&type=style&index=0&id=46e5401e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5401e",
  null
  
)

export default component.exports